export default __webpack_public_path__ + "static/media/sightxLogoWhiteWithRepdata.bb1f2be8.svg";